module.exports = __webpack_public_path__ + "static/img/apple-app-store-badge.1b659262.svg";